import React, { useCallback } from "react";

import LayerUpload from "fond/project/panels/InputPanel/LayerUpload";
import { ISGLayerIds } from "fond/types";
import { useStackedNavigationContext } from "fond/widgets";

const BoundaryUpload: React.FC = () => {
  const { open } = useStackedNavigationContext();

  const handleComplete = useCallback(() => {
    open("boundary-import");
  }, [open]);

  return (
    <LayerUpload layerId={ISGLayerIds.boundary} displayName="Boundary" title="Upload boundary" geometryType="Polygon" onComplete={handleComplete} />
  );
};

export default BoundaryUpload;
